module.exports = __webpack_public_path__ + "img/life-ring.1025ca20.svg";